export default __webpack_public_path__ + "static/media/konto_ikon.c20c99e5.png";